import React from 'react'
import { withRouter, RouteComponentProps } from 'react-router-dom'
import styled from 'styled-components'
import * as S from '../CarecoAdminDashboard/CarecoAdminStyle'
import * as St from './TopQueryStyle'
import { pendingActionIcon as PendingActionIcon } from 'uiKit/icons/Icons'

const EmptyStateWrapper = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: default;
`

const EmptyStateContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
`

const EmptyStateText = styled.div`
  font-size: 14px;
  line-height: 24px;
  font-weight: 500;
  color: #616581;
`

interface QueryItem {
  topic: string
  count: number
}

interface Props extends RouteComponentProps {
  data: QueryItem[] | null
}

const TopQueries: React.FC<Props> = ({ history, match, data }) => {
  const handleViewAll = () => {
    const baseUrl = (match as any)?.url || ''
    history.push(`${baseUrl}/top-queried-topics`)
  }

  const formatTopic = (t: string) => {
    const cleaned = (t || '').replaceAll('_', ' ').toLowerCase()
    return cleaned ? cleaned.charAt(0).toUpperCase() + cleaned.slice(1) : ''
  }

  return (
    <S.Container style={{ marginBottom: 0, display: 'flex', flexDirection: 'column', width: '100%' }}>
      <S.SectionTitle>Top queried topics </S.SectionTitle>
      <St.Card style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
        {!data || data.length === 0 ? (
          <EmptyStateWrapper>
            <EmptyStateContent>
              <PendingActionIcon />
              <EmptyStateText>No top queried topics</EmptyStateText>
            </EmptyStateContent>
          </EmptyStateWrapper>
        ) : (
          <>
            <div style={{ flex: 1 }}>
              {data.map((query, index) => (
                <St.QueryContent key={index + query.topic}>
                  <St.QueryTitle>{formatTopic(query.topic)}</St.QueryTitle>
                  <St.QueryCount>
                    {query.count} {query.count > 1 ? 'times' : 'time'}
                  </St.QueryCount>
                </St.QueryContent>
              ))}
            </div>
            <St.ViewAllButton onClick={handleViewAll}>View all</St.ViewAllButton>
          </>
        )}
      </St.Card>
    </S.Container>
  )
}

export default withRouter(TopQueries)
